module.exports = __webpack_public_path__ + "img/chevrons-left.ead35b7d.svg";